import React, { useState } from "react";
import { Steps } from "antd";
import HeaderDashboard from "../../../components/layout/header/HeaderDashboard";
import Step1 from "./OtherOwners";
import { FaUsers } from "react-icons/fa";
import { Provider } from "../../../components/MultiStepForm/MultiStepFormContext";
import "../tcGuaranteeStep.scss";

const { Step } = Steps;

const renderStep = (step) => {
  switch (step) {
    case 0:
      return <Step1 />;
  }
};

const AddOtherOwners = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [stepValue, setStepValue] = useState(0);

  const next = () => {
    const nextStep = currentStep + 1;
    if (nextStep > stepValue) {
      setStepValue(nextStep);
    }
    setCurrentStep(nextStep);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <div className="steplist-wrap guarantee-wrap">
      <HeaderDashboard />

      <div className="container">
        <div className="row">
          <Provider value={{ next, prev }}>
            <div className="stepContainer singleStep">
              <Steps
                current={currentStep}
                onChange={(step) => {
                  if (step <= stepValue) {
                    setCurrentStep(step);
                  }
                }}
                className={currentStep === 1 ? "custom-step-active" : ""}
              >
                <Step title={"Other Owners"} icon={<FaUsers />} />
              </Steps>
            </div>
            <main>{renderStep(currentStep)}</main>
          </Provider>
        </div>
      </div>
    </div>
  );
};
export default AddOtherOwners;
